import { useState, useEffect } from 'react';

export default function Preloader() {
  const [visible, setVisible] = useState(true);
  const [fading, setFading] = useState(false);

  useEffect(() => {
    const fadeTimer = setTimeout(() => setFading(true), 1200);
    const removeTimer = setTimeout(() => setVisible(false), 1800);
    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(removeTimer);
    };
  }, []);

  if (!visible) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center"
      style={{
        backgroundColor: '#060f1d',
        opacity: fading ? 0 : 1,
        transition: 'opacity 600ms ease',
        pointerEvents: fading ? 'none' : 'auto',
      }}
      data-testid="preloader"
    >
      <div className="flex flex-col items-center gap-5">
        <div className="relative">
          <div className="w-16 h-16 rounded-xl flex items-center justify-center" style={{ backgroundColor: '#0f2240', border: '1px solid rgba(201,168,76,0.3)' }}>
            <svg width="32" height="32" viewBox="0 0 20 20" fill="none">
              <path d="M4 16V4L10 10L16 4V16" stroke="#c9a84c" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <div
            className="absolute rounded-xl animate-pulse-gold"
            style={{ inset: '-6px', border: '2px solid rgba(201,168,76,0.4)' }}
          />
        </div>
        <span className="font-playfair text-2xl font-bold tracking-tight">
          <span className="text-white">ALC</span>
          <span style={{ color: '#c9a84c' }}>BOND</span>
        </span>
      </div>
    </div>
  );
}
